import { render, staticRenderFns } from "./bgDividers.vue?vue&type=template&id=2295e694"
import script from "./bgDividers.vue?vue&type=script&lang=js"
export * from "./bgDividers.vue?vue&type=script&lang=js"
import style0 from "./bgDividers.vue?vue&type=style&index=0&id=2295e694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports